import React from 'react';
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';
const uuid = require('uuid');
const map = require('lodash/map');
const Moment = require('moment');

const LocalAssignmentsStore = require('../../stores/local_assignments_store');
const AssignmentActions = require('../../actions/AssignmentActions');
import TileListEmpty from '../tiles/TileListEmpty';
import SortableTableClassic from '../table/SortableTableClassic';
import ConfirmModal from '../modal/ConfirmModal';

const propTypes = {
    className: PropTypes.string,
};
const defaultProps = {
    className: '',
};

class LocalAssignmentsInstructorView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localAssignmentStoreState: LocalAssignmentsStore.getState(),
            deleteAssignmentHash: null,
            deleteAssignmentActionId: null,
            deleteAssignmentError: null,
        };

        this.assignmentClickHandler = this.assignmentClickHandler.bind(this);
        this.assignmentDeleteHandler = this.assignmentDeleteHandler.bind(this);
        this.handleDeleteAssignment = this.handleDeleteAssignment.bind(this);
        this.handleCancelDeleteAssignment = this.handleCancelDeleteAssignment.bind(this);
        this.unsubscribes = [
            LocalAssignmentsStore.listen(this.onLocalAssignmentStoreChange.bind(this))
        ];
    }

    UNSAFE_componentWillMount() {
        if (!this.state.localAssignmentStoreState.requested) {
            AssignmentActions.getLocalAssignments(uuid.v4());
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onLocalAssignmentStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.deleteAssignmentActionId) {
            if (!state.action.error) {
                additionalState = {
                    ...additionalState,
                    deleteAssignmentHash: null,
                    deleteAssignmentActionId: null,
                    deleteAssignmentError: null,
                };
            }
            else {
                additionalState = {
                    ...additionalState,
                    deleteAssignmentError: state.action.error,
                }
            }
        }

        this.setState({
            localAssignmentStoreState: state,
            ...additionalState,
        });
    }

    assignmentClickHandler(e, hash, something) {
        window.location.href = `/assignment/${hash}/mzl_instructor`;
    }

    assignmentDeleteHandler(rowKey, columnKey) {
        const hash = rowKey;
        this.setState({ deleteAssignmentHash: hash });
    }

    handleDeleteAssignment() {
        const deleteAssignmentActionId = uuid.v4();
        this.setState({ deleteAssignmentActionId: deleteAssignmentActionId }, () => {
            AssignmentActions.archiveAssignment(deleteAssignmentActionId, { hash: this.state.deleteAssignmentHash });
        });
    }

    handleCancelDeleteAssignment() {
        this.setState({
            deleteAssignmentHash: null,
            deleteAssignmentError: null,
        });
    }

    render() {
        const self = this;
        let elems;
        if (this.state.localAssignmentStoreState) {
            if (this.state.localAssignmentStoreState.localAssignments && (this.state.localAssignmentStoreState.localAssignments.length > 0)) {
                var tableColumns = [
                    {displayName: 'Title',          key: 'title',       size: 3, type: 'string' },
                    // {displayName: 'Description',    key: 'description', size: 3, type: 'string' },
                    {displayName: 'Template',       key: 'templateName', size: 3, type: 'string' },
                    {displayName: 'Create Date',    key: 'create_date',  size: 3, type: 'date', sortKey: 'raw_date' },
                    {displayName: 'Start Date',     key: 'start_date',   size: 3, type: 'date', sortKey: 'raw_start_date' },
                    {displayName: 'End Date',       key: 'end_date',     size: 3, type: 'date', sortKey: 'raw_end_date' },
                    {displayName: 'Student Count',  key: 'studentCount', size: 3, type: 'int' },
                    {displayName: 'Delete',         key: 'deleteButton', size: 1, type: 'iconButton' }, // custom cell type
                ];

                var tableRows = map(this.state.localAssignmentStoreState.localAssignments, function(assignment) {
                    var date = new Moment(assignment.create_date);
                    var dateString = date.format("MMMM D YYYY");

                    return {
                        key: assignment.hash,
                        title: assignment.name,
                        raw_date: assignment.create_date,
                        create_date: dateString,
                        raw_start_date: assignment.start_date,
                        raw_end_date: assignment.end_date,
                        start_date: assignment.start_date ? (new Moment(assignment.start_date).format("MMMM D YYYY")) : '',
                        end_date: assignment.end_date ? (new Moment(assignment.end_date).format("MMMM D YYYY")) : '',
                        // description: assignment.description,
                        templateName: assignment.templateName,
                        studentCount: assignment.students,
                        deleteButton: {
                            className: 'assignment-delete-button fa fa-trash',
                            onClick: self.assignmentDeleteHandler.bind(self,assignment.hash)
                        }
                    };
                });
                elems = (
                    <div className="local-assignment-table">
                        <SortableTableClassic key="t-local-assignments"
                            title="Assignments"
                            onRowClick={this.assignmentClickHandler}
                            rows={tableRows}
                            uniqueRowKey="key"
                            defaultSort={{ key:'raw_date', type:'date', asc: false }}
                            columns={tableColumns}
                        />
                    </div>
                );
            }
            else {
                elems = ( <TileListEmpty promptText={this.state.localAssignmentStoreState.loading ? "Loading..." : "No Local Assignments."} /> );
            }
        }
        else {
            elems = ( <TileListEmpty promptText="Loading..."/> );
        }

        return (
            <div className={this.props.className}>
                {elems}
                {!!this.state.deleteAssignmentHash &&
                    <ConfirmModal
                        show
                        modalTitle="Delete Assignment"
                        text="Are you sure you want to delete this assignment?"
                        buttonText="delete"
                        hasError={!!this.state.deleteAssignmentError}
                        message={!!this.state.deleteAssignmentError ? this.state.deleteAssignmentError.message : null}
                        closeHandler={this.handleCancelDeleteAssignment}
                        confirmHandler={this.handleDeleteAssignment}
                    />
                }
            </div>
        );
    }
}

LocalAssignmentsInstructorView.propTypes = propTypes;
LocalAssignmentsInstructorView.defaultProps = defaultProps;

export default withRouter(LocalAssignmentsInstructorView);